// extracted by css-extract-rspack-plugin
export default {"group":"XwOCREtAmuE_extX","legend":"J2jVtoD6b8sU81jO"};